import React from 'react';
import CountUp from 'react-countup';
import ReactVisibilitySensor from "react-visibility-sensor";
import { TypeAnimation } from 'react-type-animation';
import me from '../../Assets/me.jpg'
import './Home.css'
import '../../App.css'

import {
  Ripple,
  initTE,
} from "tw-elements";
import { useState, useEffect, useRef } from 'react';

const Home = () => {

  

  initTE({ Ripple });
  const myButtonRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [viewPortEntered, setViewPortEntered] = useState(false);


  const scrollToSection = (sectionId) => {
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });

    }
  };



  const scrollFunction = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollFunction);

    return () => {
      window.removeEventListener('scroll', scrollFunction);
    };
  }, []);
  return (
    <div className='px-3' id='#home'>
      <section className="text-white flex overflow-hidden  content justify-center md:px-10 lg:px-20  max-w-[1400px]  mx-auto">
        <div className=" flex flex-col-reverse   md:flex mt-24  sm:py-12 lg:py-10 lg:flex-row  ">
          <div
            data-aos="zoom-out"
            data-aos-duration="1500"
            className="flex flex-col justify-center mt-3 md:mt-0  p-2 text-center rounded-sm  lg:text-left">
            <h1 className="text-4xl md:text-6xl font-bold leading-none sm:text-6xl">
              Hi, I'm Saroar Jahan
            </h1>
            <h3 className='text-3xl  md:text-4xl mt-1 font-bold text-[#9572ff]  rounded-lg'>  <span className='text-3xl md:text-4xl'>a_</span>
              <TypeAnimation
                sequence={[
                  'Web Developer',
                  1000,
                  'Frontend Developer',
                  1000,
                  'MERN-stack Developer',
                  1000
                ]}
                wrapper="span"
                speed={10}
                style={{ display: 'inline-block' }}
                repeat={Infinity}
              /></h3>
            <p className="mt-6 mb-8 text-gray-400 text-lg text-justify md:text-left sm:mb-12">
              I am Saroar Jahan Bappy, a web developer focused on MERN Stack web experiences. Designing and Coding have been my passion since the days I started working with computers but I found myself into web development since 2022.
            </p>
            <div className="flex   space-x-2 justify-center    sm:items-center     lg:justify-start">
              <button
                onClick={() => scrollToSection(`#contact`)}
                data-te-ripple-init
                data-te-ripple-color="light"

                className="px-8 py-3 animate-btn    bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-lg font-semibold rounded-[4px]"
              >
                Hire Me
              </button>
              <button
                onClick={() => scrollToSection(`#about`)}
                data-te-ripple-init
                data-te-ripple-color="light"

                className="px-8 py-3   border   border-gray-400 text-lg font-semibold rounded-[4px]"
              >
                Know More
              </button>

            </div>

            <div

              data-aos="fade-up"
              data-aos-duration="1000"

              className="  py-10 md:py-10 text-gray-200">
              <div className=" md:-ml-12  grid  grid-cols-2 md:grid-cols-4   text-center  ">
                <div className="flex flex-col  p-2 border-dashed border-b md:border-b-0 border-r   border-gray-700 justify-start   lg:m-6">
                  <span className="text-4xl font-semibold lg:text-6xl">
                    <CountUp duration={3} start={viewPortEntered ? null : 0} end={2}>
                      {({ countUpRef }) => {
                        return (
                          <ReactVisibilitySensor
                            active={!viewPortEntered}
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setViewPortEntered(true);
                              }
                            }}
                            delayedCall
                          >
                            <span className="number" ref={countUpRef} />
                          </ReactVisibilitySensor>
                        );
                      }}
                    </CountUp>Y+
                  </span>
                  <span className="text-sm text-gray-400 font-semibold sm:text-lg">  Experience</span>
                </div>
                <div className="flex flex-col  p-2 border-dashed border-r-0 border-b md:border-b-0 md:border-r border-gray-700 justify-start  lg:m-6">
                  <span className="text-4xl font-semibold lg:text-6xl">
                    <CountUp duration={3} start={viewPortEntered ? null : 0} end={20}>
                      {({ countUpRef }) => {
                        return (
                          <ReactVisibilitySensor
                            active={!viewPortEntered}
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setViewPortEntered(true);
                              }
                            }}
                            delayedCall
                          >
                            <span className="number" ref={countUpRef} />
                          </ReactVisibilitySensor>
                        );
                      }}
                    </CountUp>+
                  </span>
                  <span className="text-sm text-gray-400 font-semibold sm:text-lg">Projects</span>
                </div>
                <div className="flex flex-col  p-2 border-dashed border-r lg:border-r border-gray-700 justify-start  lg:m-6">
                  <span className="text-4xl font-semibold lg:text-6xl">
                    <CountUp duration={3} start={viewPortEntered ? null : 0} end={50}>
                      {({ countUpRef }) => {
                        return (
                          <ReactVisibilitySensor
                            active={!viewPortEntered}
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setViewPortEntered(true);
                              }
                            }}
                            delayedCall
                          >
                            <span className="number" ref={countUpRef} />
                          </ReactVisibilitySensor>
                        );
                      }}
                    </CountUp>+
                  </span>
                  <span className="text-sm text-gray-400 font-semibold sm:text-lg">Repository</span>
                </div>
                <div className="flex flex-col  p-2 border-dashed justify-start   lg:m-6">
                  <span className="text-4xl font-semibold lg:text-6xl">
                    <CountUp duration={3} start={viewPortEntered ? null : 0} end={10}>
                      {({ countUpRef }) => {
                        return (
                          <ReactVisibilitySensor
                            active={!viewPortEntered}
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setViewPortEntered(true);
                              }
                            }}
                            delayedCall
                          >
                            <span className="number" ref={countUpRef} />
                          </ReactVisibilitySensor>
                        );
                      }}
                    </CountUp>+
                  </span>
                  <span className="text-sm text-gray-400 font-semibold sm:text-lg">Happy Clients</span>
                </div>

              </div>
            </div>
          </div>
          <div
            data-aos="zoom-out"
            data-aos-duration="1500"
            className="flex items-center  self-center w-full justify-center lg:justify-end    "  >
            <img
              src={me}
              alt=""
              className="h-[500px] border-2 border-indigo-700  rounded-tl-3xl rounded-br-3xl  "
            />
          </div>
        </div>

      </section>

      {/* scroll down  */}
      <div className='flex justify-center py-20'>
        <svg className="arrows">
          <path class="a1" d="M0 0 L30 32 L60 0"></path>
          <path class="a2" d="M0 20 L30 52 L60 20"></path>
          <path class="a3" d="M0 40 L30 72 L60 40"></path>
        </svg>
      </div>


      {/*Linked In shortcut fix button  */}
      {/* <a

        href="https://www.linkedin.com/in/saroar-jahan-bappy/"
        target='_blank '
      >
        <button

          type="button"
          class="mb-2 inline-block rounded-full p-3 fixed bottom-16 right-5   hover:transition-all     z-[999] overflow-visible text-xs font-medium uppercase leading-normal text-white bg-blue-600   duration-300 ease-in-out transition-all  hover:bg-gradient-to-r from-[#4E10FF] to-[#AB17DF]"
           >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path
              d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
          </svg>
        </button>
      </a> */}

      {/*  Messenger  shortcut fix button */}
      <a
        href="https://wa.me/message/ELV4LMH3RMGRO1"
        target='_blank '
      >
        <button
          type="button"
          class="mb-2 inline-block hover:animate-btn rounded-full p-[10px] fixed bottom-16 right-5     z-[999] overflow-visible text-xs font-medium uppercase leading-normal text-white  transition-colors duration-500    hover:bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] "
          style={{ backgroundColor: "#25D366" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path
              d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
          </svg>
        </button>
      </a>

      {/* back to top button fix button  */}
      {isVisible && (

        <button

          id="btn-back-to-top"
          ref={myButtonRef}
          className=" text-white fixed bottom-4 right-5  animate-bounce  z-[999] overflow-visible bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] p-3 rounded-full"
          onClick={backToTop}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            class="h-4 w-4"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512">
            <path
              fill="currentColor"
              d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path>
          </svg>
        </button>
      )}



    </div>
  );
};

export default Home;